import Vue from 'vue';
import * as ElementUi from 'element-ui';
import lang from 'element-ui/lib/locale/lang/ru-RU';
import locale from 'element-ui/lib/locale';

locale.use(lang);

Vue.use(ElementUi, {locale: lang});
